import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toastActions } from "@base-provider";

import { syncTenantSkills } from "../../services/tenantService";

const SyncTenantSkills = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(toastActions.showInfoMessage("Tenant Skills Sync started"));
    syncTenantSkills(id);
  }, []);

  return <></>;
};

export default SyncTenantSkills;